import { Component, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { EventService } from '../../../core/services/event.service';
import { MENU, MENURECHERCHE } from './menu';
import { MenuItem } from './menu.model';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { BehaviorSubject } from 'rxjs';
import { MenuService } from 'src/app/shared/service/fetchservice/fetchservice';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-horizontalnavbar',
  templateUrl: './horizontalnavbar.component.html',
  styleUrls: ['./horizontalnavbar.component.scss'],
})
export class HorizontalnavbarComponent implements OnInit, AfterViewInit {

  configData;
  menuItems = [];
  filteredMenuItems: MenuItem[] = [];

  acces: any = "";
  accessMenu: any;

  accesProjet: any;
  accessExecution: any;

  acessSousMenu: any
  // tslint:disable-next-line: max-line-length
  constructor(
    private router: Router,
    private eventService: EventService,
    private localStorage: LocalStorageService,
    private menuService: MenuService,
    private cdr: ChangeDetectorRef
  ) {
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.activateMenu();
      }
    });
  }

  ngOnInit(): void {


    //this.acces = this.localStorage.getAcessUser();

    this.acessSousMenu = this.localStorage.getInfoUserToService()?.data?.direction_code;

    this.accessMenu = this.localStorage.getInfoUserToService();
    console.log("this.accessMenu", this.accessMenu);


    this.accessExecution = this.localStorage.getExerciceToUserToSuivieEvaluation()

    this.accesProjet = this.localStorage.getProjetToUser();

    //this.initialize();


    this.initializeMenu();

    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3
    };
  }

  openDropdown(id: string, closeOthers: boolean = false) {
    // Fermer tous les autres dropdowns du même niveau si demandé
    if (closeOthers) {
      document.querySelectorAll('.topnav .dropdown-menu.show').forEach(el => {
        if (el.id !== id) el.classList.remove('show');
      });
    }

    const el = document.getElementById(id);
    if (!el) return;

    el.classList.add('show');

    // Corriger la position si le menu dépasse à droite
    setTimeout(() => {
      const rect = el.getBoundingClientRect();
      if (rect.right > window.innerWidth) {
        el.style.left = 'auto';
        el.style.right = '0';
      } else {
        el.style.left = '';
        el.style.right = '';
      }
    }, 0);
  }

  closeMenu(event: MouseEvent) {
  const li = event.currentTarget as HTMLElement;
  li.querySelectorAll('.show').forEach(el => {
    el.classList.remove('show');
  });
}
  closeDropdown(id: string) {
    const el = document.getElementById(id);
    if (el) {
      el.classList.remove('show');
      // Fermer aussi les sous-menus enfants
      el.querySelectorAll('.dropdown-menu.show').forEach(sub => {
        sub.classList.remove('show');
      });
    }
  }
  initializeMenu(): void {
    const userGroup = this.accessMenu?.data?.groupe;
    const userDirection = this.accessMenu?.data?.service?.direction.sigle; // La direction de l'utilisateur
    const accessExecution = this.accessExecution; // Récupération de la valeur d'accessExecution

    // Passer accessExecution à la méthode updateMenu
    this.menuService.updateMenu(userGroup, userDirection, accessExecution);

    this.menuService.menuItems$.subscribe(menuItems => {
      this.menuItems = menuItems;
      this.filteredMenuItems = this.menuItems;

      this.cdr.detectChanges(); // Forcer la détection des changements 
    });
  }

 
  handleMenuClick(item: MenuItem): void {
    if (item.disabled) {
      if (item.accessMessage) {
        // Affiche le message d'accès refusé (adapte selon ton système de toast/modal)
        alert(item.accessMessage);
        // ou : this.toastr.warning(item.accessMessage, 'Accès refusé');
      }
      return; // stopper la navigation
    }
    if (item.link) {
      this.router.navigate([item.link]);
    }
  }

  showAccessDenied(item: MenuItem, event: Event): void {

    event.preventDefault();
    event.stopPropagation();

    const message = item.accessMessage ||
      'Vous n\'avez pas accès à cette section.\nSeuls les administrateurs et les agents du service DAAF peuvent y accéder.';

    Swal.fire({
      icon: 'warning',
      title: 'Accès refusé',
      text: message,
      confirmButtonText: 'OK',
      confirmButtonColor: '#3085d6'
    });
  }
  /**
   * On menu click
   */
  onMenuClick(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    const trigger = event.currentTarget as HTMLElement;
    const menu = trigger.nextElementSibling as HTMLElement | null;

    // Aucun sous-menu → rien à ouvrir
    if (!menu || !menu.classList.contains('dropdown-menu')) {
      return;
    }

    // Fermer tous les autres menus frères
    const parent = trigger.parentElement;
    if (parent) {
      const siblings = parent.querySelectorAll('.dropdown-menu.show');
      siblings.forEach(s => {
        if (s !== menu) s.classList.remove('show');
      });
    }

    // Toggle du menu actuel
    menu.classList.toggle('show');
  }


  ngAfterViewInit() {
    this.activateMenu();
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Togglemenu bar
   */
  toggleMenubar() {
    const element = document.getElementById('topnav-menu-content');
    element.classList.toggle('show');
  }

  /**
   * Activates the menu
   */
  private activateMenu() {

    const resetParent = (el: any) => {
      const parent = el.parentElement;
      if (parent) {
        parent.classList.remove('active');
        const parent2 = parent.parentElement;
        this._removeAllClass('mm-active');
        this._removeAllClass('mm-show');
        if (parent2) {
          parent2.classList.remove('active');
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove('active');
            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.remove('active');
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove('active');
              }
            }
          }
        }
      }
    };

    // activate menu item based on location
    const links = document.getElementsByClassName('side-nav-link-ref');
    let matchingMenuItem = null;
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // reset menu
      resetParent(links[i]);
    }
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // tslint:disable-next-line: no-string-literal
      if (location.pathname === links[i]['pathname']) {
        matchingMenuItem = links[i];
        break;
      }
    }

    if (matchingMenuItem) {
      const parent = matchingMenuItem.parentElement;
      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add('active');
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.add('active');
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add('active');
            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.add('active');
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.add('active');
              }
            }
          }
        }
      }
    }
  }

  /**
   * Topbar light
   */
  topbarLight() {
    document.body.setAttribute('data-topbar', 'light');
    document.body.removeAttribute('data-layout-size');
  }

  /**
   * Set boxed width
   */
  boxedWidth() {
    document.body.setAttribute('data-layout-size', 'boxed');
    document.body.setAttribute('data-topbar', 'dark');
  }

  /**
   * Change the layout onclick
   * @param layout Change the layout
   */
  changeLayout(layout: string) {
    this.eventService.broadcast('changeLayout', layout);
  }

  /**
   * Initialize
   */
  initialize(): void {

    if (this.acces?.code === "suivie") {
      this.menuItems = MENU;

    }
    if (this.acces?.code === "recherche-valorisation") {
      this.menuItems = MENURECHERCHE;

    }
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }



}
